import { cx } from '@linaria/core';
import { TransitionGroup } from 'react-transition-group';
import { AccessCodes } from '@pm2/api';
import { useCourseRevisionState, useCanDisableChapterInRevision, useActiveRevision, courseRevisionsStore } from '@pm2/course-revisions';
import { pm2SitemapStore, findCourseDescriptorFromParents } from '@pm2/sitemap-utils';
import { Tooltip, Switch } from '@ui/kit';
import { SizeTransition } from '@utils/react';
import { headerCls, switchCls, headingCls, groupCls } from './chapter-group.style.js';
import { NavItem } from './nav-item.js';
import { switchTransitionCls } from './nav-item.style.js';
import { courseRevisionEditTransitionDurationMs, navItemTransitionCls } from './nav-layer.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function ChapterGroup({
  parentDescriptor,
  onLinkClick,
  ref
}) {
  const sitemap = pm2SitemapStore.useSelector(state => state);
  const courseDescriptor = findCourseDescriptorFromParents(sitemap, parentDescriptor);
  const isEditingRevision = useCourseRevisionState(state => state.isEditing);
  const isEnabledInRevision = useCourseRevisionState(state => parentDescriptor.children?.some(child => !state.disabledIds[child.id]?.disabled) ?? false);
  const canDisableChapterGroupInRevision = useCanDisableChapterInRevision(courseDescriptor, parentDescriptor.children);
  const activeRevision = useActiveRevision(courseDescriptor?.id);
  if (!parentDescriptor.children?.length) {
    // ignore empty chapter groups from navigation, they don't contain any
    // meaningful links anyway
    return null;
  }
  const handleRevisionToggle = async () => {
    parentDescriptor.children?.map(async chapterDescriptor => {
      courseRevisionsStore.dispatch(courseRevisionsStore.actions.toggleChapter({
        disabled: isEnabledInRevision,
        chapterId: chapterDescriptor.id
      }));
    });
  };
  return /*#__PURE__*/jsxs("li", {
    ref: ref,
    className: cx(groupCls, navItemTransitionCls),
    children: [/*#__PURE__*/jsxs("div", {
      className: headerCls,
      children: [/*#__PURE__*/jsx(SizeTransition, {
        axis: "horisontal",
        in: isEditingRevision,
        timeout: courseRevisionEditTransitionDurationMs,
        classNames: switchTransitionCls,
        mountOnEnter: true,
        unmountOnExit: true,
        children: ref => /*#__PURE__*/jsx("div", {
          ref: ref,
          className: switchTransitionCls,
          children: /*#__PURE__*/jsx(Tooltip, {
            body: "Du skal have mindst \xE9t kapitel tilg\xE6ngeligt i forl\xF8bet",
            disabled: canDisableChapterGroupInRevision || !isEnabledInRevision,
            placement: "top",
            ariaType: "description",
            children: ref => /*#__PURE__*/jsx("div", {
              ref: ref,
              className: switchCls,
              children: /*#__PURE__*/jsx(Switch, {
                checked: isEnabledInRevision,
                disabled: !canDisableChapterGroupInRevision && isEnabledInRevision,
                onChange: handleRevisionToggle
              })
            })
          })
        })
      }), /*#__PURE__*/jsx("h6", {
        className: headingCls,
        children: parentDescriptor.title
      })]
    }), /*#__PURE__*/jsx("ul", {
      children: /*#__PURE__*/jsx(TransitionGroup, {
        component: null,
        children: parentDescriptor.children.filter(childDescriptor => childDescriptor.accessCode === AccessCodes.ALLOWED && !childDescriptor.hidden && (isEditingRevision || !activeRevision?.disabledContentIds[childDescriptor.id]?.disabled)).map(childDescriptor => {
          return /*#__PURE__*/jsx(SizeTransition, {
            axis: "vertical",
            timeout: courseRevisionEditTransitionDurationMs,
            classNames: navItemTransitionCls,
            delayMs: {
              enter: 100,
              exit: 100
            },
            children: ref => /*#__PURE__*/jsx(NavItem, {
              ref: ref,
              pageDescriptor: childDescriptor,
              onLinkClick: onLinkClick
            }, childDescriptor.id)
          }, childDescriptor.id);
        })
      })
    })]
  });
}

export { ChapterGroup };
//# sourceMappingURL=chapter-group.js.map
